"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllianceCustomerContactTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
const nullable_1 = require("../common/nullable");
exports.AllianceCustomerContactTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    email: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String({ format: 'email' }))),
    firstName: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    lastName: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    phoneNumber: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    department: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    locationPreferences: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.String())),
    notes: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    sendBillingEmails: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Boolean())),
    sendDispatchEmails: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Boolean())),
    primaryContact: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Boolean())),
});
//# sourceMappingURL=alliance-customer-contact-transport.js.map